import { ref, watchEffect } from 'vue'
import { useHelpers, useTranslate } from '@/shared/lib'
import { cloneDeep } from 'lodash'
import { useLoadCabinetReportCurrent } from './api'

const useModel = () => {
  const data = ref<any[]>([])
  const total = ref(0)

  const { toTimeFormat, numToKilo } = useHelpers()
  const { trs } = useTranslate()

  const headers = ref<any>([
    { title: '№', key: 'index', sortable: false },
    { title: trs('itf.name'), key: 'name', sortable: false },
    { title: trs('itf.mater_number'), key: 'serial_number', sortable: false },
    {
      title: trs('itf.ktt'),
      key: 'ktt',
      sortable: false,
    },
    {
      title: trs('itf.date'),
      key: 'date',
      value: (item: any) => toTimeFormat(item.date, 'dd.MM.yyyy HH:mm:ss'),
      sortable: false,
    },
    {
      title: trs('itf.postfix_u', { label: 'Ua' }),
      key: 'u_a',
      sortable: false,
    },
    {
      title: trs('itf.postfix_u', { label: 'Ub' }),
      key: 'u_b',
      sortable: false,
    },
    {
      title: trs('itf.postfix_u', { label: 'Uc' }),
      key: 'u_c',
      sortable: false,
    },
    {
      title: trs('itf.postfix_i', { label: 'Ia' }),
      key: 'i_a',
      sortable: false,
    },
    {
      title: trs('itf.postfix_i', { label: 'Ib' }),
      key: 'i_b',
      sortable: false,
    },
    {
      title: trs('itf.postfix_i', { label: 'Ic' }),
      key: 'i_c',
      sortable: false,
    },
    {
      title: trs('itf.postfix_p', { label: 'Pa' }),
      key: 'p_a',
      value: (item: any) => numToKilo(item.p_a),
      sortable: false,
    },
    {
      title: trs('itf.postfix_p', { label: 'Pb' }),
      key: 'p_b',
      value: (item: any) => numToKilo(item.p_b),
      sortable: false,
    },
    {
      title: trs('itf.postfix_p', { label: 'Pc' }),
      key: 'p_c',
      value: (item: any) => numToKilo(item.p_c),
      sortable: false,
    },
    {
      title: trs('itf.postfix_p', { label: 'P' }),
      key: 'p',
      value: (item: any) => numToKilo(item.p_a + item.p_b + item.p_c),
      sortable: false,
    },
    {
      title: trs('itf.postfix_q', { label: 'Qa' }),
      key: 'q_a',
      value: (item: any) => numToKilo(item.q_a),
      sortable: false,
    },
    {
      title: trs('itf.postfix_q', { label: 'Qb' }),
      key: 'q_b',
      value: (item: any) => numToKilo(item.q_b),
      sortable: false,
    },
    {
      title: trs('itf.postfix_q', { label: 'Qc' }),
      key: 'q_c',
      value: (item: any) => numToKilo(item.q_c),
      sortable: false,
    },
    {
      title: 'cos φ a',
      key: 'cos_a',
      sortable: false,
    },
    {
      title: 'cos φ b',
      key: 'cos_b',
      sortable: false,
    },
    {
      title: 'cos φ b',
      key: 'cos_b',
      sortable: false,
    },
  ])

  /**
   * Функция загрузки таблицы
   */
  const loadTable = (filter: any) => {
    const result = useLoadCabinetReportCurrent(filter)

    watchEffect(() => {
      if (result.data.value) {
        /** Выставляем значения по умолчанию для null */
        data.value = cloneDeep(result.data.value.data || []).map((item: any) => {
          for (let prop in item) {
            item[prop] = item[prop] === null ? '-' : item[prop]
          }

          return item
        })

        total.value = data.value.length
      }
    })

    return result
  }

  return {
    data,
    headers,
    total,

    loadTable,
  }
}

export default useModel
